class GoogleMapSingleNursery {
	constructor() {
		this.container = document.querySelector(".google-map-individual");
		this.googleMap = document.querySelector(".google-map-single-nursery");
		if (this.googleMap) {
			this.buildTheMap();
		}
	}

	buildTheMap() {
		let lat = this.googleMap.dataset.lat;
		let lng = this.googleMap.dataset.lng;
		let zoom = parseInt(this.googleMap.dataset.zoom);
		let markerPointer = this.googleMap.dataset.pointer;
		let project = this.googleMap.dataset.project;


		if ( lat && lng) {
			let map = new google.maps.Map(this.googleMap, {
				center: new google.maps.LatLng(lat, lng),
				zoom: zoom,
				maxZoom: 18,
				disableDefaultUI: true,
				styles: googleMapStyle

			});

			new google.maps.Marker({
				position: { lat: parseFloat(lat), lng: parseFloat(lng) },
				map: map,
				icon:  mapHelper.googleMapIcon(markerPointer, project)
			});
		}
	}
}